import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Layout from '../views/Layout.vue'
import { getCurrentUser, getRoleHome } from '../utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue')
      },

      {
        path: 'appointment-audit',
        name: 'AppointmentAudit',
        component: () => import('../views/AppointmentAudit.vue')
      },
      {
        path: 'appointment-audit-detail/:id',
        name: 'AppointmentAuditDetail',
        component: () => import('../views/AppointmentAuditDetail.vue')
      },
      {
        path: 'broker-auth-audit-detail/:id',
        name: 'BrokerAuthAuditDetail',
        component: () => import('../views/BrokerAuthAuditDetail.vue')
      },
      {
        path: 'user-manage',
        name: 'UserManage',
        component: () => import('../views/UserManage.vue')
      },
      {
        path: 'driver-manage',
        name: 'DriverManage',
        component: () => import('../views/DriverManage.vue')
      },
      {
        path: 'broker-auth-audit',
        name: 'BrokerAuthAudit',
        component: () => import('../views/BrokerAuthAudit.vue')
      },
      {
        path: 'grain-type-manage',
        name: 'GrainTypeManage',
        component: () => import('../views/GrainTypeManage.vue')
      },
      {
        path: 'warehouse-manage',
        name: 'WarehouseManage',
        component: () => import('../views/WarehouseManage.vue')
      },
      {
        path: 'modbus-device',
        name: 'ModbusDevice',
        component: () => import('../views/ModbusDevice.vue')
      },
      {
        path: 'warehouse-monitoring-config',
        name: 'WarehouseMonitoringConfig',
        component: () => import('../views/WarehouseMonitoringConfig.vue')
      },
      {
        path: 'outbound-dispensing',
        name: 'OutboundDispensing',
        component: () => import('../views/OutboundDispensing.vue')
      },
      {
        path: 'vehicle-grain-monitoring',
        name: 'VehicleGrainMonitoring',
        component: () => import('../views/VehicleGrainMonitoring.vue')
      },
      {
        path: 'qrcode-manage',
        name: 'QRCodeManage',
        component: () => import('../views/QRCodeManage.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const user = getCurrentUser()

  if (to.path === '/login') {
    if (token) {
      next(getRoleHome(user.role))
    } else {
      next()
    }
    return
  }

  if (!token) {
    next('/login')
    return
  }

  if (to.path === '/' || to.path === '/dashboard') {
    if (user.role === 'storekeeper') {
      next('/vehicle-grain-monitoring')
      return
    }
    if (user.role === 'sales') {
      next('/broker-auth-audit')
      return
    }
  }

  next()
})

export default router
